const makeDownload = (content, name) => {
	const file = new File([content], name, { type: 'application/octet-binary' });
	const link = document.createElement('a');
	link.href = window.URL.createObjectURL(file);
	link.download = name;
	link.click();
};

export default makeDownload;
